(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-items"]) return;
  try {
    
  let form = document.forms['cart-form'];
  let formUpdateClass = 'cart-items__form--updating';

  let inputs = document.querySelectorAll('.quantity-input__input');
  let checkout = document.querySelector('#checkout-button');

  for (let input of inputs) {
    input.addEventListener('quantity-update', (e) => updateCart(e));
  }
  
  function updateDOM(query, parsedHTML) {
    const srcElement = parsedHTML.querySelector(query);
    const targetElement = document.querySelector(query);

    if (srcElement && targetElement) {
      targetElement.replaceWith(srcElement);
    }
  }

  function updateCart(e) {
    let id = e.detail.id;
    let invalid = e.detail.invalid;
    let target = e.target;
    let value = e.detail.value;

    if (invalid || !id || isNaN(value) || !form || !target) {
      return;
    }

    let itemKey = id.replace('quantity-', '');
    let formData = new FormData();

    formData.append(`updates[${itemKey}]`, value);
    formData.append('sections', 'cart-items');
    formData.append('sections_url', window.location.pathname);

    form.classList.add(formUpdateClass);
    target.disabled = true;
    checkout.disabled = true;

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      body: formData
    })
    .then((response) => { return response.json(); })
    .then((responseData) => {
      const sectionIds = ['cart-items'];
      const sections = responseData.sections;

      for (const sectionId of sectionIds) {
        const serializedHTML = sections[sectionId];
        const parsedHTML = new DOMParser().parseFromString(serializedHTML, 'text/html');

        const lineItemTotalQuery = `#${ CSS.escape(itemKey) }-line-price`;
        updateDOM(lineItemTotalQuery, parsedHTML);

        const subtotalQuery = '#cart-items-subtotal';
        updateDOM(subtotalQuery, parsedHTML);
      }

      form.classList.remove(formUpdateClass);
      target.disabled = false;
      checkout.disabled = false;
    })
  }

  } catch(e) { console.error(e); }
})();
})();
